import './BackLink.css';
import { useFrameOwnsBack } from './FrameBack';

export interface BackLinkProps {
  label: string;
  onClick: () => void;
}

// "‹ Today" etc — the one way out of a screen reached by drilling in.
//
// CV5 §2: it renders NOTHING when the frame around it is already showing the
// way back. One change here covers every screen that uses this component
// (SourceViewer, AuditionDetail, ProjectDetail, Materials, Settings, Account)
// — the alternative was six near-identical edits and a seventh screen someone
// forgets. The frame only claims the duty on the phone stack, so the desktop
// rail and the two-pane detail pane (where `onClick` means "de-select", not
// "leave") are untouched, as is every test that mounts a screen on its own.
export function BackLink({ label, onClick }: BackLinkProps) {
  if (useFrameOwnsBack()) return null;
  return (
    <button type="button" class="back-link" onClick={onClick}>
      <span aria-hidden="true">‹</span> {label}
    </button>
  );
}
